import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["id", "container", "options", "customComponents", "isPrerenderMode", "eventsListener", "isAccessible", "staticMediaUrls", "children", "styles"];
import React from 'react';
import { ProGallery } from 'pro-gallery';
import { getResizeMediaUrl } from '@wix/native-pro-gallery-utils';
import '../../gallery.global.scss';
export const WixProGalleryBase = _ref => {
  let id = _ref.id,
    container = _ref.container,
    options = _ref.options,
    customComponents = _ref.customComponents,
    isPrerenderMode = _ref.isPrerenderMode,
    eventsListener = _ref.eventsListener,
    isAccessible = _ref.isAccessible,
    staticMediaUrls = _ref.staticMediaUrls,
    children = _ref.children,
    styles = _ref.styles,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "pro-gallery-wix-wrapper",
    style: styles
  }, /*#__PURE__*/React.createElement(ProGallery, _extends({}, props, {
    id,
    options,
    container,
    // @ts-expect-error
    createMediaUrl: getResizeMediaUrl(staticMediaUrls),
    totalItemsCount: props.items.length,
    // To Be replaced with totalItemsCount API
    settings: {
      isAccessible
    },
    eventsListener,
    isPrerenderMode,
    customComponents
  })), children);
};
//# sourceMappingURL=gallery.js.map